import { Button, Card, Stack, useTheme } from '@mui/material';
import FormProvider from 'src/components/hook-form/form-provider';
import RHFTextArea from 'src/components/hook-form/rhf-text-area';
import ClearIcon from '@mui/icons-material/Clear';
import { RHFMultiSelect } from 'src/components/hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import RHFRadioGroupLegacy from 'src/components/hook-form/rhf-radio-group-legacy';
import { useMyDataStore } from 'src/store/me/me.store';

type Props = {
  hook: any;
};

export default function FaqForm({ hook }: Props) {
  const theme = useTheme();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.personalization)

  return (
    <FormProvider methods={hook.methods} onSubmit={hook.onSubmit}>
      <Card>
        <Stack spacing={2} p={4}>
          <RHFTextArea name="question" label="Pergunta" />
          <Stack spacing={1}>
            <Stack direction="row" justifyContent="flex-start">
              <Button variant="soft" onClick={() => hook.append('')}>
                Adicionar Resposta
              </Button>
            </Stack>
            {hook.fields.map((field: any, index: number) => (
              <Stack
                key={field.id}
                spacing={1}
                direction="row"
                sx={{
                  alignItems: 'center',
                }}
              >
                <RHFTextArea
                  InputProps={{
                    endAdornment: (
                      <ClearIcon
                        onClick={() => hook.remove(index)}
                        sx={{
                          cursor: 'pointer',
                          color: theme.palette.grey[600],
                          width: 15,
                          height: 15,
                        }}
                      />
                    ),
                  }}
                  key={index}
                  name={`answers[${index}]`}
                  label={`Resposta ${index + 1}`}
                />
              </Stack>
            ))}
          </Stack>
          <RHFMultiSelect name="areas" label="Áreas" options={hook.AREAS_OPTIONS} chip checkbox />
          <RHFRadioGroupLegacy
            name="status"
            options={hook.STATUS_OPTIONS}
            getOptionLabel={hook.STATUS_LABEL}
          />
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton type="submit" variant="contained" loading={hook.isSubmitting} disabled={(hook.isEdit && !permissions?.update) || (!hook.isEdit && !permissions?.create)}>
              {!hook.isEdit ? 'Cadastrar Pergunta' : 'Editar Pergunta'}
            </LoadingButton>
          </Stack>
        </Stack>
      </Card>
    </FormProvider>
  );
}
